import { render } from "./SupervisaoSisbiPoc_57.vue?vue&type=template&id=42ecda53&scoped=true"
import script from "./SupervisaoSisbiPoc_57.vue?vue&type=script&lang=js"
export * from "./SupervisaoSisbiPoc_57.vue?vue&type=script&lang=js"

import "./SupervisaoSisbiPoc_57.vue?vue&type=style&index=0&id=42ecda53&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ecda53"]])

export default __exports__